<template>
    <section class="app-main">
            <el-card class="line-item">
                <el-row class="line-item">
                    <el-col :span="2" class="input-left">
                        商品名称：
                    </el-col>
                    <el-col :span="22">
                        <el-input v-model="title" placeholder="请输入商品名称" style="width:400px"></el-input>
                    </el-col>
                </el-row>
                <el-row class="line-item">
                    <el-col :span="2" class="input-left">
                        商品主图：
                    </el-col>
                    <el-col :span="22">
                        <img-upload @success="handleImg" :img.sync="pic"  :width="150" :height="150" :clear="clear" file-name="purchase" ></img-upload>
                    </el-col>
                </el-row>
                <el-row class="line-item">
                    <el-col :span="2" class="input-left">
                        供应商名称：
                    </el-col>
                    <el-col :span="22">
                        <el-select v-model="supplier" placeholder="选择供应商" clearable class="sku-input">
                            <el-option v-for="item in supplierList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                        <el-button plain class="sku-add" @click="dialog = true">新增供应商</el-button>
                    </el-col>
                </el-row>
            </el-card>

            <el-card class="line-item" v-for="(it,i) in sku" :key="i">
                <el-row class="line-item">
                    <el-col :span="2" class="input-left">
                        商品规格：
                    </el-col>
                    <el-col :span="22">
                        <el-select v-model="it.key" placeholder="选择规格" class="sku-input">
                            <i @click="handleRemoveKey(i,$event)" slot="prefix" class="el-input__icon el-icon-delete"></i>
                            <el-option v-for="item in specData" :key="item.id" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                        <el-button plain class="sku-add" @click="handleSkuAdd()">添加规格</el-button>
                    </el-col>
                </el-row>
                <el-row class="line-item">
                    <el-col :span="2" class="input-left">
                        规格属性：
                    </el-col>
                    <el-col :span="22">
                        <el-input v-for="(item,index) in it.children" :key="index" v-model="item.value"  placeholder="输入属性名称" class="sku-input">
                            <i @click="handleRemoveValue(index,it.children)" slot="prefix" class="el-input__icon el-icon-delete"></i>
                        </el-input>
                        <el-button plain class="sku-add" @click="handleValueAdd(it.children)">添加属性</el-button>
                    </el-col>
                </el-row>
            </el-card>

            <el-card>
                <el-row class="line-item">
                    <el-col :span="2" class="input-left">
                        提交商品：
                    </el-col>
                    <el-col :span="22">
                        <el-button  @click="handleSubmit()" type="success" plain style="width:150px">确认采购</el-button>
                    </el-col>
                </el-row>
            </el-card>
         <!-- 添加供应商 -->
        <el-dialog title="新增供应商" :visible.sync="dialog" top="30vh" :show-close="false" width="600px" center>
            <el-row type="flex" justify="center">
                <el-input v-model="name" placeholder="请输入供应商名称" style="width:400px"></el-input>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button style="width:150px" @click="dialog = false">取 消</el-button>
                <el-button style="width:150px" type="primary" @click="handleSupplierAdd()">确 定</el-button>
            </div>
        </el-dialog>
    </section>
</template>
<script>
import { specs_get, purchase, get_supplier_info, post_supplier_info } from '@/api/buy.js'
import ImgUpload from '@/components/m-upload.vue'
export default {
    name:'buyUpload',
    components:{ ImgUpload },
    data () {
        return {
            supplier: '', // 供应商下拉列表
            supplierList: [], // 供应商列表
            pic:{url: '', pic_id: ''},           // 主图id  
            clear:0,             // 清空 imgUpload 内容  0 不清空；1 提交成功之后清空； 2 未提交页面发生改变 需要删除当前上传的参数；            
            title:'',
            belongs:2,
            specData:[],   // 可选规格
            sku:[{key:'',children:[{value:''}]}],        // 商品规格
            name: "",
            dialog: false
        }
    },
    methods:{
        // 供应商显示
        init() {
            get_supplier_info().then(res => {  
                if(res){
                    this.supplierList = res.data
                }
            })
        },
        handleSupplierAdd() {
            let params = {
                name: this.name
            };
            if(this.name == '') {
                this.$message.error('请完善供应商名称')
                return false
            }
            post_supplier_info(params).then(res => {  
                if(res){
                    this.$message({type:'success', message:res.msg, duration:1500})
                    this.name = ''
                    this.dialog = false
                }
            })
        },
        // 上传图片成功回调
        handleMainImgSuccess(res,file){
            this.imgList = file;
        },

        // 获取规格
        handleSpec(){
            specs_get({language:'zh'}).then(res => {
                this.specData = res.data
            })
        },

        // 添加规格
        handleSkuAdd(){
            let obj = {
                key:'',
                children:[
                    {value:''}
                ]
            }
            this.sku.push(obj)
        },

        // 删除规格
        handleRemoveKey(i,e){
            e.stopPropagation()
            if(this.sku.length > 1){
                this.sku.splice(i,1)
            }
        },
        
        handleValueAdd(arr) {
            let obj = { value:'' }
            arr.push(obj)
        },
        // 删除规格的属性
        handleRemoveValue(index,arr){
            arr.splice(index,1)
        },

        // 主图上传回调函数
        handleImg(imgId){
            this.pic = imgId
        },

        handleSubmit(){
            if(this.title == ""){
                this.$message.error('请完善商品名称')
                return false
            }
            // if(this.pic == ""){
            //     this.$message.error('请完善商品主图')
            //     return false
            // }
            if(this.spec == "{}"){
                this.$message.error('请完善商品规格属性')
                return false
            }
            let params = {
                supplier_name: this.supplier,
                title:  this.title,
                belongs:this.belongs,
                pic:    this.pic.pic_id,
                specs:  this.spec,
            }
            console.log(params)
            purchase(params).then(res => {
                if(res){
                   this.$message({type:'success', message:res.msg, duration:1500})
                   this.clearData() 
                }
            })
        },

        clearData(){
            this.supplier = ''
            this.title   = ''
            this.belongs = 2
            this.pic     = ''
            this.sku     = [{key:'',children:[{value:''}]}]
            this.clear   = 1
        },
    },
    computed: {
        // 处理sku数组，返回后台需要的参数
        spec(){
            let obj = {}
            this.sku.forEach(e => {
                if(e.key != ""){
                    let arr =[]
                    e.children.forEach(el => {
                        if(el.value != ''){
                            arr.push(el.value)
                        }
                    })
                    obj[''+e.key] = arr
                }
            })
            return JSON.stringify(obj);
        }
    },
    created(){
        this.init();
        this.handleSpec()
    },
    activated() {
        this.handleSpec()
        this.init();
    },
    beforeRouteLeave(to,form,next){
        if(this.pic != ''){
            this.clear = 2
        }
        next()
    }
}
</script>
<style lang="less" scoped>
.sizing {
    box-sizing: border-box;
}
section {
    .line-item {
        margin-bottom: 20px;
    }
    .input-left {
        height: 40px;
        line-height: 40px;
        min-width:80px ;
    }
    .avatar-uploader{
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        width: 178px;
        height: 178px;
        background: #fff;
    }
    .avatar-uploader:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .sku-value {
        height: 40px;
        line-height: 40px;
        margin:20px 15px 0 0;
    }
    .sku-input {
        width: 150px;
        margin-right: 20px;
    }
}
</style>

